import React from 'react';
import { Link } from 'react-router-dom';
import { BiMenu } from 'react-icons/bi';
import { FaSignOutAlt, FaUser } from 'react-icons/fa';
import logo from '../../assets/images/Logo.png';

function PatientHeader({ userName, onProfileClick, onLogout }) {
  const initials = userName
    ? userName
        .split(' ')
        .map((n) => n[0])
        .join('')
        .slice(0, 2)
        .toUpperCase()
    : 'PT';

  return (
    <header className="patient-top-header">
      <Link to="/patient-dashboard" className="patient-header-logo">
        <img src={logo} alt="247 ProCare" className="logo-img" />
      </Link>

      <div className="patient-header-actions">
        <div className="d-flex align-items-center gap-2">
          <div className="patient-header-avatar" title={userName}>
            {initials}
          </div>
          <span className="patient-header-name">{userName}</span>
        </div>

        <div className="dropdown">
          <button
            className="btn btn-light dropdown-toggle"
            type="button"
            id="patientUserDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style={{ minWidth: 0, padding: '0.375rem 0.75rem' }}
          >
            <BiMenu className="me-2" /> Menu
          </button>

          <ul
            className="dropdown-menu dropdown-menu-end"
            aria-labelledby="patientUserDropdown"
            style={{ minWidth: '180px' }}
          >
            <li>
              <button type="button" className="dropdown-item" onClick={onProfileClick}>
                <FaUser className="me-2" />
                My Profile
              </button>
            </li>
            <li>
              <hr className="dropdown-divider" />
            </li>
            <li>
              <button type="button" className="dropdown-item text-danger" onClick={onLogout}>
                <FaSignOutAlt className="me-2" />
                Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}

export default PatientHeader;
